import { useLocation, useNavigate } from "react-router";
import Hdashboard from "../../../components/Hdashboard";
import { useFormik } from "formik";
import * as Yup from "yup";
import React, { useEffect, useRef, useState } from "react";
import { TOAST_ERROR, TOAST_SUCCESS, convertToBase64 } from "../../../utils/common.service";
import { uploadImageOnAWS } from "../../aws/Service";
import { add_subject, get_category, get_sub_category, subject_add } from "../../../api/apiHandler";
import JqueryLoad from "../../../JqueryLoad/JqueryLoad";

export default function AddSubSubject({ isLoader }) {

    const [data, setData] = useState([])
    const navigate = useNavigate()
    const location = useLocation()
    const subcategory = location.state.subcategory
    const fileRef = useRef();
    const [image, setImage] = useState(null);
    const [mainCategory, setMainCategory] = useState([])
    const [subCategory, setSubCategory] = useState([])

    const subjectSchema = Yup.object({
        subject_name: Yup.string()
            .matches(/^[a-zA-Z0-9!@#\$%\^&\*\(\)_\+\-=\[\]{};':"\\|,.<>\/?\s]+$/, 'Please enter proper subject name')
            .required("Please enter subject name"),
        image: Yup.mixed()
            .test('fileType', 'Only image files are allowed', value => {
                if (!value) return true;
                return (value && /^image\/.+$/i.test(value.type));
            })
            .required("Please upload image"),
    });


    const subjectForm = useFormik({
        initialValues: {
            subject_name: '',
            image: null,
        },
        validationSchema: subjectSchema,
        onSubmit: async (values) => {
            try {
                isLoader(true)
                if (subjectForm.values.image != null) {
                    var subject_category_image = await uploadImageOnAWS(subjectForm.values.image, "main_category");
                }

                var obj = {
                    main_category_id: subcategory.main_category_id,
                    subject_name: subjectForm.values.subject_name,
                    category_id: subcategory.id,
                };
                if (subjectForm.values.image !== null) {
                    obj.subject_category_image = subject_category_image;
                }
                subject_add(obj).then((response) => {
                    if (response.code == 1) {
                        TOAST_SUCCESS(response.message);
                        navigate(-1);
                        isLoader(false)
                    } else {
                        TOAST_ERROR(response.message);
                        isLoader(false)
                    }
                });
            } catch (error) {
                console.log('error :', error);
                TOAST_ERROR(error)
            } finally {
                isLoader(false);
            }
        },
    });

    const uploadImage = () => {
        fileRef.current.click();
    };

    const uploadImageEvent = async (e) => {
        const imgUrl = URL.createObjectURL(e.target.files[0]);
        const bufferImage = await convertToBase64(e.target.files[0]);
        setImage(bufferImage);
        subjectForm.setFieldValue('image', e.target.files[0]);
    };

    const handleBack = () => {
        navigate(-1);
    };

    const displayError = (fieldName) =>
        subjectForm.touched[fieldName] && subjectForm.errors[fieldName];

    return <>
        <JqueryLoad />
        <Hdashboard />
        <main>
            <div className="dashboard-app d-lg-flex">
                <header className="dashboard-toolbar d-lg-flex justify-content-between">
                    <div className="align-items-center justify-content-between d-flex">
                        <div className="d-flex align-items-center">
                            <a className="menu-toggle align-items-center d-lg-none d-flex">
                                <i className="fa fa-bars" />
                            </a>
                            <a href="index.php" className="d-lg-none d-block brand-logo">
                                <img src="./assets/images/logo.png" alt="logo" />
                            </a>
                        </div>
                    </div>
                </header>
                <span onClick={handleBack} className="mt-4 mx-5">
                    <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.86172 2.225L8.37839 0.75L0.136719 9L8.38672 17.25L9.86172 15.775L3.08672 9L9.86172 2.225Z" fill="#131313" ></path>
                    </svg>

                    <span className="ms-2">Back</span>
                </span>
                <div className="container">

                    <h2 className="d-flex justify-content-center"> Add Subject</h2>
                    <div className="row align-items-center justify-content-center mt-5">
                        <div className="col-lg-8">
                            <div className="card border-purple p-4" >

                                <form onSubmit={subjectForm.handleSubmit} className="custom_form mt-4">
                                    <div className="d-flex justify-content-center">

                                        <span onClick={uploadImage}>
                                            <img
                                                src={image === null ? "./assets/images/image_upload.png" : image}
                                                alt=""
                                                className="img img-responsive card border-purple p-2"
                                                height={"100px"}
                                                width={"100px"}
                                                accept="image/*"
                                                style={{ borderRadius: "50%" }}
                                            />
                                        </span>
                                        <input
                                            type="file"
                                            ref={fileRef}
                                            className="form-control d-none"
                                            name="image"
                                            accept="image/*"
                                            onChange={uploadImageEvent}
                                        />

                                    </div>
                                    {displayError("image") && (
                                        <div className="text-danger d-flex justify-content-center">{subjectForm.errors.image}</div>
                                    )}

                                    <div className="form-group mb-4">
                                        <label className="mb-2">Subject Name:</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="subject_name"
                                            onChange={subjectForm.handleChange}
                                            // onBlur={subjectForm.handleBlur}
                                            value={subjectForm.values.subject_name}
                                        />
                                        {displayError("subject_name") && (
                                            <div className="text-danger">{subjectForm.errors.subject_name}</div>
                                        )}
                                    </div>

                                    <div className="d-flex justify-content-center mt-3">
                                        <button type="submit" className="btn-theme bg-yellow mb-xl-0 mb-3 d-inline-block">
                                            Submit
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </>
}